import { render, staticRenderFns } from "./CommunicationList.vue?vue&type=template&id=060667d2&"
import script from "./CommunicationList.vue?vue&type=script&lang=js&"
export * from "./CommunicationList.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports